import React from "react";
import { motion } from "framer-motion";
import { Plus } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/lib/store";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";
import { iconFor, tintFor } from "@/lib/categoryIcons";

export default function ProductCard({ product, storeId, accent }) {
  const navigate = useNavigate();
  const add = useCart((s) => s.add);
  const { icon: Icon, colour } = iconFor(product.category);
  const badgeColour = accent || colour;

  const onAdd = (e) => {
    e.stopPropagation();
    add(product, storeId);
    toast.success(`${product.name} added to basket`);
  };

  return (
    <motion.div
      data-testid={TID.productCard}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.985 }}
      onClick={() => navigate(`/products/${product.product_id}`)}
      className="card-panel p-3 cursor-pointer flex flex-col relative"
    >
      <span
        className="absolute -top-3 left-4 px-3 py-0.5 rounded-full text-[10px] font-black uppercase tracking-widest text-white border-2 border-[var(--text)]"
        style={{ background: badgeColour, boxShadow: "2px 2px 0 0 var(--text)" }}
      >
        {product.category}
      </span>
      <div
        className="rounded-2xl aspect-square border-2 border-[var(--text)] flex items-center justify-center overflow-hidden"
        style={tintFor(product.category)}
      >
        <Icon size={110} weight="regular" color={colour} />
      </div>
      <div className="mt-3 flex-1">
        <h4 className="text-base font-black leading-snug line-clamp-2" style={{ fontFamily: "'Fraunces', serif" }}>
          {product.name}
        </h4>
        <p className="mt-1 text-xs font-bold text-[var(--text-3)] uppercase tracking-widest">
          {product.brand}
          {product.strain ? ` · ${product.strain}` : ""}
        </p>
        {product.thc_pct > 0 && (
          <p className="mt-1 text-[11px] font-bold text-[var(--text-2)]">
            THC {product.thc_pct}% · CBD {product.cbd_pct}%
          </p>
        )}
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className="font-display text-2xl">R{product.price.toFixed(2)}</span>
        <button
          data-testid={TID.addToCartBtn}
          onClick={onAdd}
          className="inline-flex items-center justify-center w-10 h-10 rounded-full border-2 border-[var(--text)] text-white"
          style={{ background: badgeColour, boxShadow: "3px 3px 0 0 var(--text)" }}
          title="Add to basket"
        >
          <Plus size={16} weight="bold" />
        </button>
      </div>
    </motion.div>
  );
}
